import React, { createContext, useEffect } from "react";
import styles from "./partnerDashboard.module.css";
import { Outlet, useNavigate } from "react-router-dom";
import { Button } from "antd";
import { useState } from "react";
import AxiosInstance from "../../../AxiosInstance";
import { alertSuccess } from "../../Helper/Alerts";
import OtherPageHeader from "../../../components/OtherHeader";

import RoleSwitch from "../../Helper/RoleSwitch";
import CompleteProfileModel from "../../../components/Model/CompleteProfileMode";

import useLocalStorage from "../../Helper/useLocalStorage";
import PartnerNavigation from "./sub/PartnerNavigation";
export const PartnerContext = createContext(null);
export default function PartnerOutlet() {
  const [contextData, setContextData] = useLocalStorage("contextData", {
    viewMode: "INVESTOR",
  });
  const updateContextData = (key, data) => {
    const payload = { ...contextData, [key]: data };
    setContextData(payload);
  };

  const navigate = useNavigate();

  var [userRoles, setUserRoles] = useState([]);
  var [userMeData, setUserMeData] = useState("");
  const [active, setActive] = useState(true);
  const [referralCode, setRefferalCode] = useState("");

  const getUserMe = () => {
    const url = "/user/me";
    AxiosInstance()
      .get(url)
      .then((resp) => {
        if (resp.status === 200) {
          setUserMeData(resp.data.status);
          setUserRoles(resp.data.userRoles);
          setRefferalCode(resp.data.referralCode);
          const temp = resp.data.userRoles;
          const result = temp.filter(function (letter) {
            return letter !== resp.data.currentRole;
          });
          localStorage.setItem("currentRole", resp.data.currentRole);
          localStorage.setItem("userId", resp.data.userId);
          localStorage.setItem("roles", result);
          localStorage.setItem(
            "username",
            resp.data.firstName + " " + resp.data.lastName
          );
        }
      });
  };

  useEffect(() => {
    let ignore = false;

    if (!ignore) {
      getUserMe();
    }
    return () => {
      ignore = true;
    };
  }, []);

  return (
    <PartnerContext.Provider value={contextData}>
      {" "}
      <section className="tre_bg-gray position-relative">
        <OtherPageHeader
          classProps="bg-transparent  "
          innerClassProps="bg-transparent"
        />
        <div className="container d-flex justify-content-between">
          <div>
            <PartnerNavigation />
          </div>
          <div className="d-flex gap-2 flex-column flex-md-row">
            {" "}
            {contextData?.viewMode === "INVESTOR" && (
              <Button
                className={styles["partner-role-switch"]}
                onClick={() => {
                  navigate("/myearnings");
                }}
              >
                My Earnings
              </Button>
            )}
            <Button
              className={styles["partner-role-switch"]}
              onClick={() => {
                updateContextData(
                  "viewMode",
                  contextData?.viewMode === "INVESTOR"
                    ? "POLICY_MASTER"
                    : "INVESTOR"
                );
                navigate("/partnerDashboard");
              }}
            >
              {" "}
              {contextData?.viewMode === "INVESTOR"
                ? "PH Section"
                : "Investor Section"}
            </Button>
          </div>
        </div>
        <div className={`container ${styles["bg-partner"]} `}>
          <div className={`${styles["partner-dashboard-top-header"]}`}>
            <div className="mt-4"></div>
          </div>
          <div className="policies-table">
            <main>
              {" "}
              <Outlet />
            </main>
          </div>
          {userMeData.status === "NOT_UPDATED" && (
            <CompleteProfileModel
              active={active}
              setActive={setActive}
              target={userMeData.currentRole}
            />
          )}

          <RoleSwitch userRoles={userRoles} />
        </div>
      </section>
    </PartnerContext.Provider>
  );
}
